import type { TFunction } from "i18next";
import type { SourcingEventDto } from "../../../autogen/bff-api";
import { allowsPartIIDialogue } from "../rounds/partIIDialogue";

export const MAX_RELATIVE_ADVANTAGES_LENGTH = 4000;

export const relativeAdvantagesTooLong = (text: string | undefined) =>
  (text ?? "").trim().length > MAX_RELATIVE_ADVANTAGES_LENGTH;

export const relativeAdvantagesHelpText = (t: TFunction, event: SourcingEventDto, designContest: boolean): string => {
  if (allowsPartIIDialogue(event)) {
    return designContest
      ? t(
          "Sent to the rejected participants in their letter, visible to the other participants when you insert it in theirs, and the starting text for «Reason for the choice» under «Selected supplier» in the protocol. Avoid confidential details.",
        )
      : t(
          "Sent to the rejected tenderers in their letter, visible to the other suppliers when you insert it in theirs, and the starting text for «Reason for the choice» under «Selected supplier» in the protocol. Avoid confidential details.",
        );
  }
  return designContest
    ? t(
        "Sent to the rejected participants in their letter, visible to the other participants when you insert it in theirs, and the starting text for protocol § 7. Avoid confidential details.",
      )
    : t(
        "Sent to the rejected tenderers in their letter, visible to the other suppliers when you insert it in theirs, and the starting text for protocol § 7. Avoid confidential details.",
      );
};
